import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-report-performance',
  templateUrl: './detail-report-performance.component.html',
  styleUrls: ['./detail-report-performance.component.css']
})
export class DetailReportPerformanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
